<template>
  <div id="box">
    <div class="historyTag">
      <historyTag :historyArr="historyArr"></historyTag>
    </div>

    <div class="topBox flex">
      <div class="topLeft flex" style="align-items: center; flex-wrap: wrap">
        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <span style="white-space: nowrap; margin-right: 8px">订单 ID：</span>
          <div style="width: 160px">
            <el-input
              v-model="query.orderIdStr"
              placeholder="精确筛选，可选"
              clearable
              @keyup.enter.native="searchFn"
            />
          </div>
        </div>
        <el-button type="success" size="small" @click="searchFn">搜索</el-button>
        <el-button size="small" @click="resetFn">重置</el-button>
      </div>
    </div>

    <p class="hint">说明：买家在小程序「安心购订单详情」点击「提醒鉴别中心发货」后写入本列表，不进入买卖家聊天。</p>

    <div class="table-scroll-wrap">
    <el-table :data="tableData" border style="width: 100%; margin-top: 12px" v-loading="loading">
      <el-table-column prop="id" label="记录ID" width="100" align="center" />
      <el-table-column prop="orderId" label="订单ID" width="100" align="center" />
      <el-table-column prop="orderNo" label="订单号" min-width="180" align="center" show-overflow-tooltip />
      <el-table-column prop="productTitle" label="商品标题" min-width="220" class-name="cell-title-wrap" />
      <el-table-column prop="buyerNickName" label="买家昵称" width="140" align="center" show-overflow-tooltip />
      <el-table-column prop="buyerUserId" label="买家用户ID" width="120" align="center" />
      <el-table-column label="提醒时间" width="180" align="center">
        <template slot-scope="scope">{{ formatTime(scope.row.remindTime) }}</template>
      </el-table-column>
    </el-table>
    </div>

    <list-pagination
      :total="tableTotal"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      @page-change="changePage"
      @size-change="handlePageSizeChange"
    />
  </div>
</template>

<script>
import { returnTime } from "@/util/utils";

export default {
  name: "SecondhandInspectionCenterShipRemind",
  data() {
    return {
      historyArr: ["客诉处理", "催促验货发货通知"],
      loading: false,
      tableData: [],
      tableTotal: 0,
      currentPage: 1,
      pageSize: 20,
      query: {
        orderIdStr: "",
      },
    };
  },
  mounted() {
    this.fetchList(1);
  },
  methods: {
    formatTime(t) {
      if (!t) return "-";
      try {
        return returnTime(t, "-", "s");
      } catch (e) {
        return String(t);
      }
    },
    resetFn() {
      this.query = { orderIdStr: "" };
      this.currentPage = 1;
      this.fetchList(1);
    },
    searchFn() {
      this.currentPage = 1;
      this.fetchList(1);
    },
    changePage(p) {
      this.currentPage = p;
      this.fetchList(p);
    },
    handlePageSizeChange() {
      this.fetchList(1);
    },
    fetchList(page) {
      this.loading = true;
      const obj = {
        page: page || 1,
        size: this.pageSize,
      };
      const raw = String(this.query.orderIdStr || "").trim();
      if (raw) {
        const n = Number(raw);
        if (Number.isFinite(n) && n > 0) obj.orderId = n;
      }
      this.$https(this.$api.api.selSecondhandInspectionCenterShipRemindList, obj, "POST")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.tableData = res.data.data || [];
            this.tableTotal = res.data.size || 0;
          } else {
            this.tableData = [];
            this.tableTotal = 0;
            this.$message.error((res.data && res.data.msg) || "查询失败");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.hint {
  margin: 8px 0 0;
  font-size: 13px;
  color: #666;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/pages/secondhandInspectionCenterShipRemind/index.vue